import { useState } from "react";
import { BiSolidChevronDown, BiSolidChevronRight } from "react-icons/bi";
import { IoSettingsSharp } from "react-icons/io5";
import "./GroupDropdown.css";
import { Link } from "react-router-dom";
import ServerDropdown from "../ServerDropdown/ServerDropdown";
import { GetCurrentUser } from "../../../../Services/Authorization/AuthorizationManager";
import { CheckPanelPermissions } from "../../../../Services/Permissions/PermissionManager";
import { Permissions } from "../../../../Services/Permissions/Data/Permissions";

const GroupDropdown = ({group, servers}) => {
    const [hidden, setHidden] = useState(true);

    const user = GetCurrentUser();

    return (
      <>
            <div className="groupDropdownBtn center-x" onClick={() => setHidden(!hidden)}>
                <div className="dropdownArrow">
                    { hidden &&
                        <BiSolidChevronRight/> 
                    }
                    { !hidden &&
                        <BiSolidChevronDown/> 
                    }  
                </div> 
                <div className="serverDropdownData center-x">
                    { group.name &&
                        <img src={`../images/GameIcons/${group.serverType}.png`} className="size-6"/>
                    }
                    <span>{group.name ?? "Serwery bez grupy"}</span>
                </div>

                { (group.name && CheckPanelPermissions(Permissions[1], user.Permissions, true)) && 
                    <Link to={`/group/${group.id}`} onClick={(e) => {e.stopPropagation()}}>
                        <IoSettingsSharp className="iconBtn"/>
                    </Link>
                }

            </div>
            { !hidden &&
                servers.map((server) => (
                    <ServerDropdown key={`server_${server.id}`} server={server} />
                ))
            }

      </>  
    );
}

export default GroupDropdown;